'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshWidgetDataAction = undefined;
exports.refreshWidgetData = refreshWidgetData;

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

var _resetStubbedThread = require('../../stubbed-thread-history/actions/resetStubbedThread');

var _stageInitialMessage = require('../../actions/PublishActions/stageInitialMessage');

var _isCreatingThread = require('../../threads/selectors/isCreatingThread');

var _getCurrentChannel = require('../../selectors/conversationSelectors/getCurrentChannel');

var _stubbedChannel = require('../../threads/constants/stubbedChannel');

var refreshWidgetDataAction = exports.refreshWidgetDataAction = (0, _reduxActions.createAction)(_actionTypes.REFRESH_WIDGET_DATA, function (widgetData) {
  return widgetData;
});

function refreshWidgetData(widgetData) {
  return function (dispatch, getState) {
    dispatch(refreshWidgetDataAction(widgetData));

    var isStubbedThread = (0, _getCurrentChannel.getCurrentChannel)(getState()) === _stubbedChannel.STUBBED_CHANNEL;
    var isViewingStubbedThread = isStubbedThread && !(0, _isCreatingThread.isCreatingThread)(getState());

    if (isViewingStubbedThread) {
      dispatch((0, _resetStubbedThread.resetStubbedThread)());

      dispatch((0, _stageInitialMessage.stageInitialMessage)());
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/widget-data/actions/refreshWidgetData.js
// module id = 338
// module chunks = 2 3